module.exports = __webpack_public_path__ + "img/etiqueta30off.8b6c0d42.png";